const HeroSection = {
    classNames: {
        preTitle: 'hero__pre-title',
        title: 'hero__title',
        ctaOne: 'hero-cta-one',
        ctaTwo: 'hero-cta-two',
        bgImageDesktop: 'hero__backgroundImage--desktop',
        bgImageMobile: 'hero__backgroundImage--mobile'
    }
};

export default HeroSection;
